export const CANCEL_REASON = {
  PROCEDURE_UNCLEAR: 'procedure_unclear',
  PAYMENT_FAILED: 'payment_failed',
  WAITING_TOO_LONG: 'waiting_too_long',
  SCHEDULE_MISMATCH: 'schedule_mismatch',
  IDENTITY_DOCUMENT_DIFFICULT: 'identity_document_difficult',
  PRICE_TOO_HIGH: 'price_too_high',
  PLAN_MISMATCH: 'plan_mismatch',
  NO_LONGER_NEEDED: 'no_longer_needed',
  OTHER: 'other',
} as const

export type CancelReasonValue = typeof CANCEL_REASON[keyof typeof CANCEL_REASON]

/**
 * Order matters: the client specified this exact sequence, and「その他」must
 * stay last because it is the only option that reveals the free-text field.
 */
export const CANCEL_REASON_OPTIONS: {
  value: CancelReasonValue
  label: string
}[] = [
  {
    value: CANCEL_REASON.PROCEDURE_UNCLEAR,
    label: '手続きの方法が分からなかった／画面が進まなかった',
  },
  {
    value: CANCEL_REASON.PAYMENT_FAILED,
    label: 'お支払い・決済の手続きできなかった',
  },
  {
    value: CANCEL_REASON.WAITING_TOO_LONG,
    label: '診察・問診の待ち時間が長かった',
  },
  {
    value: CANCEL_REASON.SCHEDULE_MISMATCH,
    label: 'ビデオ診察の日程や環境が合わなかった',
  },
  {
    value: CANCEL_REASON.IDENTITY_DOCUMENT_DIFFICULT,
    label: '本人確認書類の提出が難しかった',
  },
  { value: CANCEL_REASON.PRICE_TOO_HIGH, label: '価格が想定より高かった' },
  {
    value: CANCEL_REASON.PLAN_MISMATCH,
    label: '提示されたお薬・プランが希望と異なった',
  },
  {
    value: CANCEL_REASON.NO_LONGER_NEEDED,
    label: '検討をやめた／必要がなくなった',
  },
  { value: CANCEL_REASON.OTHER, label: 'その他（自由記述）' },
]

export const CANCEL_REASON_TEXT_MAX_LENGTH = 1000
